export default __webpack_public_path__ + "static/media/gallery-wip-motor-housing-assembly_00.3ac67e36.jpg";